module.exports = __webpack_public_path__ + "static/img/erweima.e7a658f.png";


//////////////////
// WEBPACK FOOTER
// ./src/comm/images/document-conversion/home/erweima.png
// module id = PSnI
// module chunks = 2